(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid-slider"] && !Shopify.designMode) return;
  try {
    

(function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.collection-banner-slider',function(){
  setTimeout(function(){
    
    $(".collection-banner-slider").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '.collection-banner .swiper-button-prev',
      nextArrow: '.collection-banner .swiper-button-next',
      dots: true,
      appendDots: '.collection-banner .cus-slider-pagination',
      autoplay: true,
      autoplaySpeed: 3400,
      infinite: true,
      lazyLoad: 'anticipated',
      pauseOnFocus: true,
      pauseOnHover: true,
      centerMode: true,
      centerPadding: 'calc(8.334% - 0.25rem)',
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(13.334% - 0.25rem)'
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(15.579710% - 0.25rem)'
          }
        },
        {
          breakpoint: 667,
          settings: {
            arrows: false,
            slidesToShow: 1,
            centerPadding: 'calc(21.579710% - 0.25rem)'
          }
        }
      ]
    });

  }, 200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-column-banner"] && !Shopify.designMode) return;
  try {
    



(function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.multi-column-banner .col-banner-row',function(){

var init = false;
var swiper;
function trendingVehicleSlider() {

  if (window.innerWidth <= 1023) {
    if (!init) {
      init = true;
      swiper = new Swiper(".multi-column-banner .col-banner-row", {
        slidesPerView: 1.36,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        grabCursor: true,
        freeMode: true,
        navigation: false,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        }
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }

}

document.addEventListener('DOMContentLoaded', function() {
  trendingVehicleSlider();
});

window.addEventListener("resize", trendingVehicleSlider);

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-gallery"] && !Shopify.designMode) return;
  try {
    
(function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.instgram-banner-slider',function(){

  setTimeout(function(){
    $(".instgram-banner-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '.instgram-banner .swiper-button-prev',
      nextArrow: '.instgram-banner .swiper-button-next',
      dots: true,
      appendDots: '.instgram-banner .cus-slider-pagination',
      autoplay: true,
      autoplaySpeed: 3700,
      infinite: true,
      lazyLoad: 'anticipated',
      pauseOnFocus: true,
      pauseOnHover: true,
      centerMode: true,
      centerPadding: 'calc(8.334% - 0.25rem)',
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(13.334% - 0.25rem)'
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(15.579710% - 0.25rem)'
          }
        },
        {
          breakpoint: 667,
          settings: {
            arrows: false,
            slidesToShow: 1,
            centerPadding: 'calc(21.579710% - 0.25rem)'
          }
        }
      ]
    });
  }, 200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  window.onJQueryLoad(function($) {
    $(".link-read-more").click(function() {
      $('html,body').animate({
          scrollTop: $(".seondary-description").offset().top - 68 },'slow');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-accessories"] && !Shopify.designMode) return;
  try {
    

(function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.recommended-accessories-slider',function(){
  setTimeout(function(){
    
    $(".recommended-accessories-slider").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '.recommended-accessories-main .swiper-button-prev',
      nextArrow: '.recommended-accessories-main .swiper-button-next',
      dots: true,
      appendDots: '.recommended-accessories-main .cus-slider-pagination',
      autoplay: true,
      autoplaySpeed: 3400,
      infinite: true,
      lazyLoad: 'anticipated',
      pauseOnFocus: true,
      pauseOnHover: true,
      centerMode: true,
      centerPadding: 'calc(8.334% - 0.75rem)',
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(13.334% - 0.75rem)'
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(15.579710% - 0.75rem)'
          }
        },
        {
          breakpoint: 667,
          settings: {
            arrows: false,
            slidesToShow: 1,
            centerPadding: 'calc(21.579710% - 0.75rem)'
          }
        }
      ]
    });

  }, 200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    

(function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.recent-view-slider',function(){

  setTimeout(function(){
  $(".recent-view-slider").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '.related-products .swiper-button-prev',
      nextArrow: '.related-products .swiper-button-next',
      dots: true,
      appendDots: '.related-products .cus-slider-pagination',
      autoplay: true,
      autoplaySpeed: 3700,
      infinite: true,
      lazyLoad: 'anticipated',
      pauseOnFocus: true,
      pauseOnHover: true,
      centerMode: true,
      centerPadding: 'calc(8.334% - 0.75rem)',
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(13.334% - 0.75rem)'
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 2,
            centerPadding: 'calc(15.579710% - 0.75rem)'
          }
        },
        {
          breakpoint: 667,
          settings: {
            arrows: false,
            slidesToShow: 1,
            centerPadding: 'calc(21.579710% - 0.75rem)'
          }
        }
      ]
    });

});
},200);

setTimeout(function() {
  window.onJQueryLoad(function($) {
    if(!$('.recent-view-slider').length > 0) {
      $('.related-products').hide();
    }
  });
},1200);




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
      

      (function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.testimonial-swiper',function(){

      const swiper = new Swiper('.testimonial-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      grabCursor: true,
      freeMode: false,
      navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
            el: ".swiper-pagination",
            type: "fraction",
      },

      breakpoints: {
        1024: {
          slidesPerView: 1.8
        }
  }

      });
      });

      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icon"] && !Shopify.designMode) return;
  try {
    


(function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.icon-text-slider',function(){

function iconTextSlider() {
  window.onJQueryLoad(function($) {
    var $carousel = $(".icon-text-slider");
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile

    if (window.matchMedia('(max-width: 1023px)').matches) {

      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          settings: "unslick",
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          autoplay: true,
          autoplaySpeed:3400,
          infinite: true,
          lazyLoad: 'anticipated',
          // pauseOnFocus: false,
          // pauseOnHover: false,

          responsive: [
            {
              breakpoint: 8000,
              settings: "unslick"
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 666,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
        
    }else {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
  });
}


document.addEventListener('DOMContentLoaded', function() {
  iconTextSlider();
});

window.addEventListener("resize", iconTextSlider);

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    

(function(win) {
    'use strict';

    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;

    function ready(selector, fn) {
        // Store the selector and callback to be monitored
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // Watch for changes in the document
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // Check if the element is currently in the DOM
        check();
    }

    function check() {
        // Check the DOM for elements matching a stored selector
        for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
            listener = listeners[i];
            // Query for elements matching the specified selector
            elements = doc.querySelectorAll(listener.selector);
            for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
                element = elements[j];
                // Make sure the callback isn't invoked with the
                // same element more than once
                if (!element.ready) {
                    element.ready = true;
                    // Invoke the callback with the element
                    listener.fn.call(element, element);
                }
            }
        }
    }

    // Expose `ready`
    win.ready = ready;

})(window);

ready('.swiper-video',function(){
  setTimeout(function(){
    const swiperVideo = new Swiper('.swiper-video', {
    slidesPerView: 1.345,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    grabCursor: true,
    freeMode: false,
    navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
    breakpoints: {
        1024: {
          slidesPerView: 1.6129,
          spaceBetween: 10,
        }
      }
    });
  }, 100);
});


  } catch(e) { console.error(e); }
})();
})();
